module.exports = __webpack_public_path__ + "static/media/MHRP75N0006.a0e79b89.svg";